<template>
  <button
    @click.prevent="handleClick"
    :disabled="!isInitial"
  >
    <span class="font_icon left fa fa-envelope fa-1x"></span>
    <span class="text">Send request to subscribers</span>
  </button>

  <!-- <a class="option_button black align_right send_request_bt" data-id="<?php echo $image_request->get_post_id(); ?>" href="javascript:void(0);"/>
			</a> -->
</template>

<script>
const STATE_INITIAL = 0,
  STATE_UPDATING = 1; 

export default {
  name: 'InterfaceEmailRequestButton',
  props: {
    postId: Number,
  },
  computed: {
    isInitial: {
        get () {
            return this.currentState === STATE_INITIAL;
        },
    },
    isUpdating: {
        get () {
            return this.currentState === STATE_UPDATING;
        },
    },
  },
  data: function(){
    return {
      currentState: null,
    }
  },
  created: function () {
    console.log("InterfaceEmailRequestButton created");
    this.currentState = STATE_INITIAL;
  },
  methods: {
    handleClick() {
      this.send();
    },
    send() {
      this.currentState = STATE_UPDATING;
      const self = this;
      const data = {
        post_id: this.postId,
      }

      this.axios.post(window.baseUrl + 'api/emailrequest', data).then(response => {
        // console.log(response.data.responseResult.data);
        console.log(response.data.responseResult);
        // self.notes = response.data.responseResult.data;
        self.onSendComplete();
      });
    },
    onSendComplete() {
      // this.currentState = STATE_INITIAL;
    },
  }
}
</script>
